import { useRef, useCallback } from 'react';

function useGetSync(value) {
  const ref = useRef(value);
  ref.current = value;
  return useCallback(() => ref.current, []);
}

export { useGetSync };
//# sourceMappingURL=useGetSync.js.map
